// images
import mainGarden1 from "../assets/mainPage/mainGarden1.webp";
import podgotovka1 from "../assets/otherPages/garden/podgotovka_1.webp";
import podgotovka2 from "../assets/otherPages/garden/podgotovka_2.webp";
import podgotovka3 from "../assets/otherPages/garden/podgotovka_3.webp";

import mainGarden2 from "../assets/mainPage/mainGarden2.webp";
import vybortepl1 from "../assets/otherPages/garden/vybor_tepl_1.webp";
import vybortepl2 from "../assets/otherPages/garden/vybor_tepl_2.webp";

import mainGarden3 from "../assets/mainPage/mainGarden3.webp";
import podgotovkaplod1 from "../assets/otherPages/garden/podgotovka_plod_1.webp";
import podgotovkaplod2 from "../assets/otherPages/garden/podgotovka_plod_2.webp";

import polivaemRastenia1 from "../assets/otherPages/garden/polivaem_rast1.webp";
import polivaemRastenia2 from "../assets/otherPages/garden/polivaem_rast2.webp";
import polivaemRastenia3 from "../assets/otherPages/garden/polivaem_rast3.webp";

import teplicaSvoimi1 from "../assets/otherPages/garden/teplica_svoimi1.webp";
import teplicaSvoimi2 from "../assets/otherPages/garden/teplica_svoimi3.webp";
import teplicaSvoimi3 from "../assets/otherPages/garden/teplica_svoimi2.webp";

// garden articles
export const gardenArticles = [
  // ARTICLE 1 START
  {
    id: "Подготовка почвы для посева",
    img: mainGarden1,
    pretitle: "Сад и огород",
    title: "Подготовка почвы для посева",
    tagString: "грунт почва посев грядка урожай теплица перегной",
    tags: [
      {
        tag: "грунт",
        tagLink: "#",
      },
      {
        tag: "почва",
        tagLink: "#",
      },
      {
        tag: "посев",
        tagLink: "#",
      },
      {
        tag: "грядка",
        tagLink: "#",
      },
      {
        tag: "урожай",
        tagLink: "#",
      },
      {
        tag: "теплица",
        tagLink: "#",
      },
      {
        tag: "перегной",
        tagLink: "#",
      },
    ],
    linkToArticle: "/garden/Подготовка почвы для посева",
    text: [
      {
        attribute: "paragraph",
        content:
          "Земельные работы на приусадебном участке начинаются, как правило, в апреле. Ориентироваться следует по состоянию грунта — почва должна быть достаточно просохшей.",
      },
      {
        attribute: "image",
        content: podgotovka1,
      },
      {
        attribute: "paragraph",
        content:
          "В теплице следует заменить верхний слой почвы на перегной, сделать временную грядку и засеять ее быстрорастущей зеленью — салатами, редисом и т. д. Месяц спустя, после снятия урожая, можно высаживать томаты или другие виды растений.",
      },
      {
        attribute: "paragraph",
        content:
          "Перекопанные с осени участки, необходимо прорыхлить тяжелыми граблями, чтобы восстановить структуру почвы. А не подготовленные места следует вскопать и разрыхлить, убирая при этом корни сорняков.",
      },
      {
        attribute: "image",
        content: podgotovka2,
      },
      {
        attribute: "paragraph",
        content:
          "Все сорняки, прошлогодние листья и другие растительные отходы отправляйте в компостник. Стоит заметить, что капустные кочерыжки и корни томатов могут быть переносчиками различных болезней — их в компост добавлять не рекомендуется. Чтобы компост быстрее перегорал, следует перекидать его вилами.",
      },
      {
        attribute: "image",
        content: podgotovka3,
      },
      {
        attribute: "paragraph",
        content:
          "Грядки делаются за 3-5 дней до посадки, а непосредственно перед посевом, боронятся граблями.",
      },
      {
        attribute: "paragraph",
        content:
          "Картофель высаживают в лунки, заправленные перегноем, на расстоянии 30-50 см, в зависимости от сорта — для поздних сортов расстояние должно быть больше, так как их надо будет окучивать.",
      },
      {
        attribute: "paragraph",
        content:
          "Стоит защитить все посадки в открытый грунт укрывным материалом, чтобы они не пострадали от майских заморозков.",
      },
      {
        attribute: "paragraph",
        content:
          "Обработка целинного участка начинается со снятия дерна, после чего он переворачивается травой вниз и накрывается темной пленкой. После того, как дерн перепреет, сюда можно высаживать землянику или томаты.",
      },
    ],
  },
  // ARTICLE 1 END

  // ARTICLE 2 START
  {
    id: "Выбор теплицы",
    img: mainGarden2,
    pretitle: "Сад и огород",
    title: "Выбор теплицы",
    tagString: "теплица парник",
    tags: [
      {
        tag: "теплица",
        tagLink: "#",
      },
      {
        tag: "парник",
        tagLink: "#",
      },
    ],
    linkToArticle: "/garden/Выбор теплицы",
    text: [
      {
        attribute: "paragraph",
        content:
          "Теплица является незаменимым средством для выращивания рассады, овощей, ягод, различных экзотических растений и цветов, причём используя дополнительное оборудование, это можно делать в течении всего года, не зависимо от климата. Данная инструкция поможет вам правильно выбрать теплицу, соответствующую именно вашим нуждам. Делая выбор стоит помнить о размерах вашего участка, а также о том какие именно культуры вы собираетесь выращивать в теплице.",
      },
      {
        attribute: "paragraph",
        content:
          "Условно теплицы различаются по типу покрытия(поликарбонат, плёнка, стекло), по материалу(металл, дерево, алюминий, пластик) и форме каркаса.",
      },
      {
        attribute: "image",
        content: vybortepl1,
      },
      {
        attribute: "title",
        content: "Теплицы из поликарбоната",
      },
      {
        attribute: "paragraph",
        content:
          "Безусловно самый популярный материал покрытия это сотовый поликарбонат. Он отлично рассеивает солнечные лучи, гарантируя равномерное распределение света, великолепно сохраняет температуру внутри теплицы. Из всех материалов он самый прочный и долговечный.",
      },
      {
        attribute: "title",
        content: "Теплицы покрываемые плёнкой",
      },
      {
        attribute: "paragraph",
        content:
          "Современные плёнки, обладая неплохими упругими свойствами, и довольно хорошо пропуская солнечный свет, всё же имеют существенные недостатки: плохо сохраняют тепло, легко рвутся, разрушаются под действием ультрафиолетовых лучей.",
      },

      {
        attribute: "title",
        content: "Теплицы из стекла",
      },
      {
        attribute: "paragraph",
        content:
          "Подобные теплицы встречаются всё реже по причине хрупкости стекла и его относительной дороговизны. Безусловным преимуществом стекла является высокая светопроницаемость. Устанавливая подобную теплицу следует внимательно отнестись к выбору каркаса, который должен быть прочным.",
      },
      {
        attribute: "paragraph",
        content: "Каркас теплиц может быть:",
      },
      {
        attribute: "list",
        content: [
          { item: "металлическим(стальной уголок)" },
          { item: "деревянным" },
          { item: "алюминиевым(дюралюминий и другие лёгкие сплавы)" },
          { item: "пластиковым(ПНД)" },
        ],
      },
      {
        attribute: "image",
        content: vybortepl2,
      },
      {
        attribute: "paragraph",
        content:
          "Несомненно самый надёжный каркас делается из оцинкованного металлического профиля толщиной не менее 1,3 мм.",
      },
      {
        attribute: "paragraph",
        content:
          "Достоинствами деревянного каркаса являются прочность и относительная дешевизна, однако  они нивелируются малым сроком службы.",
      },
      {
        attribute: "paragraph",
        content:
          "Сложно отметить достоинства пластиковых каркасов кроме их низкой стоимости и простого монтажа. Снежная зима или сильный ветер могут послужить причиной разрушения такой теплицы.",
      },
      {
        attribute: "paragraph",
        content:
          "Что касается формы, то их существует огромное множество: арочная, пирамидальная, пристенная, односкатная, двускатная и т. д. Опытные садоводы рекомендуют теплицы с прямыми стенами и арочной, либо двускатной формой крыши, стоящей на открытом пространстве, такая форма позволяет свету свободно проникать внутрь и великолепно удерживает тепло.",
      },
      {
        attribute: "paragraph",
        content:
          "Подводя итог — лучшим выбором является отдельно стоящая теплица с вертикальными стенами и двустворчатой или арочной крышей; с каркасом из прочного оцинкованного профиля; покрытая поликарбонатом.",
      },
      {
        attribute: "paragraph",
        content: "Рекордного урожая!",
      },
    ],
  },
  // ARTICLE 2 END

  // ARTICLE 3 START
  {
    id: "Подготовка плодовых деревьев и кустарников к зиме",
    img: mainGarden3,
    pretitle: "Сад и огород",
    title: "Подготовка плодовых деревьев и кустарников к зиме",
    tagString: "осень зима плодовые кустарники деревья урожай",
    tags: [
      {
        tag: "осень",
        tagLink: "#",
      },
      {
        tag: "зима",
        tagLink: "#",
      },
      {
        tag: "плодовые",
        tagLink: "#",
      },
      {
        tag: "кустарники",
        tagLink: "#",
      },
      {
        tag: "деревья",
        tagLink: "#",
      },
      {
        tag: "урожай",
        tagLink: "#",
      },
    ],
    linkToArticle: "/garden/Подготовка плодовых деревьев и кустарников к зиме",
    text: [
      {
        attribute: "paragraph",
        content:
          "Осень в календаре дачника — ответственная пора. От грамотно проведенных осенних работ в саду, зависит качество собранного урожая и то, каким он будет в будущем году.",
      },
      {
        attribute: "paragraph",
        content:
          "Далее приведен список общих рекомендаций по проведению осенних работ для плодовых кустарников и деревьев.",
      },
      {
        attribute: "paragraph",
        content:
          "Как правило сбор урожая яблок и груш, наступает в первой половине сентября. Если вы хотите, чтобы они сохранились по-дольше, то убирать их нужно до полного созревания. Чтобы определить степень зрелости, необходимо разрезать плод и посмотреть какого цвета семечки, для долгого хранения лучше всего подходят плоды со светло-коричневыми семенами.",
      },
      {
        attribute: "paragraph",
        content:
          "Все засохшие на ветвях и опавшие плоды рекомендуется утилизировать. Собранные плоды складываются в коробки или ящики с опилками и убираются на хранение.",
      },
      {
        attribute: "image",
        content: podgotovkaplod1,
      },
      {
        attribute: "paragraph",
        content:
          "После снятия урожая, наступает пора уборки сада и обрезки деревьев. С деревьев срезают засохшие и старые ветви, а также удаляют пораженные вредителями участки коры. Желательно срезать ветви которые растут внутрь кроны. Трещины и раны замазывают садовым варом во влажную погоду. Установленные ловчие пояса можно оставить до наступления холодов. Опавшие листья утилизируются или закладываются в компостную кучу.",
      },
      {
        attribute: "image",
        content: podgotovkaplod2,
      },
      {
        attribute: "paragraph",
        content:
          "После уборки земля вокруг деревьев перекапывается и подкармливается калийно-фосфорными удобрениями. Не забудьте как следует полить почву перед внесением удобрений.",
      },
      {
        attribute: "paragraph",
        content:
          "Обрезка ягодных кустарников значительно повышает их урожайность на будущий год. Старые и пересохшие ветви обрезают на уровне земли. Кусты малины связывают в пучки и пригибают. После обрезки, растения подкармливаются и окучиваются.",
      },
      {
        attribute: "paragraph",
        content:
          "Во второй половине сентября можно приступать к пересадке плодовых.",
      },
      {
        attribute: "paragraph",
        content:
          "Перед наступлением холодов производится влагозарядный подзимний полив плодовых деревьев. После чего деревья необходимо побелить.",
      },
      {
        attribute: "paragraph",
        content: "Богатого урожая!",
      },
    ],
  },
  // ARTICLE 3 END

  // ARTICLE 4 START
  {
    id: "Поливаем растения правильно",
    img: polivaemRastenia1,
    pretitle: "Сад и огород",
    title: "Поливаем растения правильно",
    tagString: "сад огород полив растения садоводство урожай",
    tags: [
      {
        tag: "сад",
        tagLink: "#",
      },
      {
        tag: "огород",
        tagLink: "#",
      },
      {
        tag: "полив",
        tagLink: "#",
      },
      {
        tag: "растения",
        tagLink: "#",
      },
      {
        tag: "садоводство",
        tagLink: "#",
      },
      {
        tag: "урожай",
        tagLink: "#",
      },
    ],
    linkToArticle: "/garden/Поливаем растения правильно",
    text: [
      {
        attribute: "paragraph",
        content:
          "Неискушенному в садоводстве человеку может показаться странной сама постановка вопроса: что растения, оказывается, можно поливать неправильно? Однако практика показывает — грамотный полив снижает риск заболевания растений различными грибками, повышает урожайность, приводит к уменьшению роста сорняков.",
      },
      {
        attribute: "paragraph",
        content:
          "Одно из главных правил — старайтесь поливать реже. Частый полив приводит к формированию поверхностной корневой системы, из-за этого растения будут нуждаться в поливе еще чаще. Это приведет к вымыванию минеральных веществ и уплотнению почвы, а также росту сорняков. Хороший, но редкий полив приводит к образованию глубокой корневой системы, которая повышает устойчивость растений перед засухой. Корнеплоды(свекла, морковь и т. д.) являются исключением из этого правила — их следует поливать часто. Также интенсивность полива любых растений зависит от погоды и типа почвы. В жаркую погоду и легкие, песчаные почвы — орошаем чаще, а в прохладную и тяжелые, глинистые почвы — реже.",
      },
      {
        attribute: "image",
        content: polivaemRastenia2,
      },
      {
        attribute: "paragraph",
        content:
          "Полив следует производить утром — до 9 часов, а вечером — с 17 до 20. Не стоит поливать днем, это приводит растения в шоковое состояние, причина тому большая разница температур воды и воздуха.",
      },
      {
        attribute: "paragraph",
        content:
          "Растения предрасположенные к грибковым заболеваниям, например томаты, необходимо поливать под корень.",
      },
      {
        attribute: "image",
        content: polivaemRastenia3,
      },
      {
        attribute: "paragraph",
        content:
          "Еще одна рекомендация заключается в избежании перелива. Избыточная влага, вытесняя из почвы кислород, приводит к загниванию корневой системы. Чрезмерное увлажнение скажется в итоге на вкусовых качествах плодов — они станут водянистыми.",
      },
      {
        attribute: "paragraph",
        content:
          "Теплолюбивые растения желательно поливать теплой водой, либо холодной, но только вечером и тонкой струйкой, чтобы вода успела прогреться, проходя сквозь почву.",
      },
      {
        attribute: "paragraph",
        content:
          "И пару слов о «сухом поливе». Так называют рыхление, снижающее испарение влаги. При рыхлении разрушаются капилляры, ведущие к глубоким слоям почвы, по которым поднимается вода. Разрыхление производят на глубину до 5 см., на следующий, после полива, день.",
      },
    ],
  },
  // ARTICLE 4 END

  // ARTICLE 5 START
  {
    id: "Теплица своими руками. Правильные советы.",
    img: teplicaSvoimi1,
    pretitle: "Сад и огород",
    title: "Теплица своими руками. Правильные советы.",
    tagString: "теплица парник огород растения садоводство урожай",
    tags: [
      {
        tag: "теплица",
        tagLink: "#",
      },
      {
        tag: "парник",
        tagLink: "#",
      },
      {
        tag: "огород",
        tagLink: "#",
      },
      {
        tag: "растения",
        tagLink: "#",
      },
      {
        tag: "садоводство",
        tagLink: "#",
      },
      {
        tag: "урожай",
        tagLink: "#",
      },
    ],
    linkToArticle: "/garden/Теплица своими руками. Правильные советы.",
    text: [
      {
        attribute: "paragraph",
        content:
          "На первый взгляд может показаться, что строительство теплицы своими руками, задача весьма сложная, но воспользовавшись советами из этой статьи вы убедитесь, что, во-первых, это совсем не сложно, а во-вторых, гораздо выгоднее покупки готовой теплицы.",
      },
      {
        attribute: "paragraph",
        content: "Для начала определяем основные параметры будущей теплицы:",
      },
      {
        attribute: "list",
        content: [
          {
            item: "как вы планируете использовать теплицу: только в летний период или круглый год",
          },
          { item: "выбрать подходящий участок под строительство" },
          { item: "определить какой она будет формы и размера" },
          { item: "из какого материал будет каркас" },
          { item: "а также материал покрытия" },
        ],
      },
      {
        attribute: "paragraph",
        content:
          "А теперь обо всём по порядку. Если вы решили сделать теплицу, которая будет функционировать в течении всего года, то следует учитывать следующие рекомендации. Желательно разместить теплицу ближе к дому, это упростит подключение электрических приборов внутри теплицы. Также важно расположить строение по линии восток — запад , это также подойдёт и для летнего варианта, при таком расположении растения получают максимальное количество солнечного света.",
      },
      {
        attribute: "paragraph",
        content:
          "Определяемся с участком под строительство. «Правильное» место должно соответствовать нескольким критериям: участок не должен быть низменным, лишняя влага ни к чему, вокруг должно быть минимум затеняющих объектов(заборы, деревья, кустарники,строения), и при этом он должен быть достаточно ровным и хорошо защищённым от ветра.",
      },
      {
        attribute: "paragraph",
        content:
          "Определившись с подходящим участком, определяем оптимальные размеры будущей теплицы. Здесь важно помнить об удобстве использования внутреннего пространства теплицы. Важнейшие параметры это ширина дорожки и высота над ней. Для наиболее комфортной работы подойдёт ширина дорожки 60 см, так при общей ширине теплицы 3 м получается по две грядки по 1,2 м у каждой стенки. Длина же теплицы зависит от размеров участка и от поставленных задач. Наиболее подходящее соотношение: при ширине 3м длина от 6 до 8м. Высота должна быть не менее двух метров.",
      },
      {
        attribute: "paragraph",
        content:
          "Формы теплиц могут быть самые разнообразные: арочные, одно- или двускатные. Стоит отметить что пристенные(односкатные) теплицы — отличное решение, в условиях отсутствия достаточного места для строительства полноразмерной теплицы. Арочные конструкции наиболее популярны из-за своей практичности, минимуме затрат на материалах, а также установленные на фундаменте, становятся отличным вариантом «зимней» теплицы. Двускатная теплица, также очень популярная, обладает пожалуй одним недостатком: относительной сложностью строительства.",
      },
      {
        attribute: "image",
        content: teplicaSvoimi2,
      },
      {
        attribute: "paragraph",
        content:
          "Для возведения каркаса подойдут следующие материалы: металл, дерево, оцинкованные сплавы, пластик. Самым надёжным безусловно является квадратный профиль толщиной не менее 1,3мм из оцинкованной стали.",
      },
      {
        attribute: "image",
        content: teplicaSvoimi3,
      },
      {
        attribute: "paragraph",
        content:
          "Покрыть теплицу можно стеклом, плёнкой или поликарбонатом. Особенности применения стекла: хрупкость, вес и сложность крепления. Каркас должен быть очень жёстким. К преимуществам использования плёнки можно отнести низкую стоимость, удобство закрепления. Из явных недостатков: плохо сохраняют тепло, недолговечны. Поликарбонат — лучший вариант покрытия теплицы, отлично распределяет свет, сохраняет температуру, прочный и долговечный.",
      },
      {
        attribute: "paragraph",
        content:
          "Итак подведём итог. Теплица возведённая на возвышенном, хорошо освещённом месте, из оцинкованного металлического профиля и поликарбоната, имеющая размеры 3х2,5х6м, является самым лучшим вариантом.",
      },
      {
        attribute: "paragraph",
        content: "Отличных урожаев!",
      },
    ],
  },
  // ARTICLE 5 END
];
